import { Command } from '@/app/common/base/command'
import { Consumer } from '@/app/identity'

export class GetPartnerDataCommand extends Command {
    public async run(): Promise<Consumer> {
        const response = await this.client.get(`/api/consumers/partner`)
        return response.asEntity(Consumer)
    }
}
